import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLogin }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);

    const handleValidation = async () => {
        try {
            const response = await fetch('/api/validate_login_password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password })
            });

            const data = await response.json();

            if (data.valid) {
                onLogin();
            } else {
                setError(true);
            }
        } catch (err) {
            console.error('Login error:', err);
            setError(true);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleValidation();
        }
    };

    return (
        <div className="login-container">
            {/* Background medical theme can be handled via CSS or an SVG */}
            <div className="login-content">
                <h1 className="title">CHAP-R1</h1>
                <h2 className="subtitle">Clinical History Acquisition Partner (v1.0)</h2>

                <div className="input-group">
                    <input
                        type="password"
                        placeholder="Enter Password"
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setError(false);
                        }}
                        onKeyPress={handleKeyPress}
                        className={error ? 'error' : ''}
                        autoComplete="new-password"
                        name="password_fake_field"
                    />
                </div>
            </div>

            <div className="login-footer">
                <div className="copyright">
                    &copy; 2026 Dr. Mike Weldon
                </div>
            </div>
        </div>
    );
};

export default Login;
